import { useTranslation } from 'react-i18next'
import { useDispatch, useSelector } from 'react-redux'
import { selectPageConfigurationData } from '@/store/PageConfiguration/PageConfigurationSelectors'
import { selectGryvChecklist } from '../../SubscriptionForm/SubscriptionFormSelectors'
import {
  updateGryvChecklistCheckedTitle,
  toggleGryvChecklistExpanded
} from '../../SubscriptionForm/SubscriptionFormSlice'

const useGryvChecklist = () => {
  const { t } = useTranslation()
  const dispatch = useDispatch()
  const initialData = useSelector(selectPageConfigurationData)
  const leadSource = initialData?.contact?.lead_source ?? ''
  const { checkedTitles, expanded } = useSelector(selectGryvChecklist)

  const isGryvLeadSource = leadSource => {
    if (!leadSource) return false
    return leadSource.toLowerCase().includes('gryv')
  }

  const isGryv = isGryvLeadSource(leadSource)

  const allTitlesChecked = Object.values(checkedTitles).every(Boolean)
  const gryvChecklistCompleted = !isGryv || allTitlesChecked

  const setCheckedTitle = (key, checked) => dispatch(updateGryvChecklistCheckedTitle({ key, checked }))
  const toggleExpanded = key => dispatch(toggleGryvChecklistExpanded(key))

  const introductionChecklist = {
    title: t('subscriptionForm:gryv_checklist.introduction_checklist.title'),
    items: [
      t('subscriptionForm:gryv_checklist.introduction_checklist.condition_1')
    ]
  }

  const identityChecklist = {
    title: t('subscriptionForm:gryv_checklist.identity_checklist.title'),
    items: [
      t('subscriptionForm:gryv_checklist.identity_checklist.condition_1'),
      t('subscriptionForm:gryv_checklist.identity_checklist.condition_2')
    ]
  }

  const presentationChecklist = {
    title: t('subscriptionForm:gryv_checklist.presentation_checklist.title'),
    items: [
      t('subscriptionForm:gryv_checklist.presentation_checklist.condition_1')
    ]
  }

  const visitPurposeChecklist = {
    title: t('subscriptionForm:gryv_checklist.visit_purpose_checklist.title'),
    items: [
      t('subscriptionForm:gryv_checklist.visit_purpose_checklist.condition_1')
    ]
  }

  const recapChecklist = {
    title: t('subscriptionForm:gryv_checklist.recap_checklist.title'),
    items: [
      t('subscriptionForm:gryv_checklist.recap_checklist.condition_1'),
      t('subscriptionForm:gryv_checklist.recap_checklist.condition_2'),
      t('subscriptionForm:gryv_checklist.recap_checklist.condition_3')
    ]
  }

  return {
    isGryv,
    introductionChecklist,
    identityChecklist,
    presentationChecklist,
    visitPurposeChecklist,
    recapChecklist,
    checkedTitles,
    expanded,
    setCheckedTitle,
    toggleExpanded,
    gryvChecklistCompleted
  }
}

export default useGryvChecklist
